import { NavDropdown } from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";
import { MapView } from "../../../../../constant/VectorTileLayerType";
import { useAuthContext } from "../../../../auth/AuthContext";
import { jwtDecode } from "jwt-decode";
import { useMemo } from "react";

const DataCutterViewOptions = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAuthContext();

  const isDataCutterActive = location.pathname === "/";
  const isCensusActive = location.pathname === `/view/${MapView.GB_CENSUS}`;
  const isRouteLineActive = location.pathname === `/view/${MapView.ROUTE_LINE}`;

  const licenceName = useMemo(() => {
    if (!user?.token) return undefined;
    const payload = jwtDecode(user.token) as any;
    return payload.LicenceName;
  }, [user]);

  return (
    <>
      <NavDropdown.Item
        active={isDataCutterActive}
        onClick={() => navigate("/")}
      >
        DataCutter
      </NavDropdown.Item>
      <NavDropdown.Item
        active={isCensusActive}
        onClick={() => navigate(`/view/${MapView.GB_CENSUS}`)}
      >
        GB Census
      </NavDropdown.Item>
      {(licenceName?.includes("Gold") || licenceName?.includes("Basemap")) && (
        <NavDropdown.Item
          active={isRouteLineActive}
          onClick={() => navigate(`/view/${MapView.ROUTE_LINE}`)}
        >
          Route Lines
        </NavDropdown.Item>
      )}
    </>
  );
};

export default DataCutterViewOptions;
